export const planstoneTempDocTypes = {
  session: 'planstoneSession',
  speaker: 'planstoneSpeaker',
}
